import {
  BottomSheet,
  DialogFooter,
  SystemInlineBanner,
  Text,
  TextButton,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { getTheme } from "@clipboard-health/ui-theme";
import { Box, ThemeProvider } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { Link } from "react-router-dom";

export interface UnableToAccessChartingBottomSheetProps {
  modalState: UseModalState;
  shiftId?: string;
  workplaceId?: string;
  workerId?: string;
  onMessageWorkplace?: () => void;
  onContactSupport?: () => void;
  onClose?: () => void;
}

export function UnableToAccessChartingBottomSheet({
  modalState,
  shiftId,
  workplaceId,
  workerId,
  onMessageWorkplace,
  onContactSupport,
  onClose,
}: UnableToAccessChartingBottomSheetProps) {
  const logMetadata = {
    shiftId,
    workplaceId,
    workerId,
  };

  const handleMessageWorkplace = () => {
    logEvent(APP_V2_USER_EVENTS.CHARTING_CREDENTIALS_UNABLE_ACCESS_MESSAGE_WORKPLACE, logMetadata);
    onMessageWorkplace?.();
    modalState.closeModal();
    onClose?.();
  };

  const handleContactSupport = () => {
    logEvent(APP_V2_USER_EVENTS.CHARTING_CREDENTIALS_UNABLE_ACCESS_CONTACT_SUPPORT, logMetadata);
    onContactSupport?.();
    modalState.closeModal();
    onClose?.();
  };

  const handleClose = () => {
    logEvent(APP_V2_USER_EVENTS.CHARTING_REMINDER_VIEW_MY_LOGIN, logMetadata);
    modalState.closeModal();
    onClose?.();
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <BottomSheet
        canDismiss
        modalState={modalState}
        header={<BottomSheetHeader onClose={handleClose} />}
        onClose={handleClose}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Text bold variant="h3" sx={{ textAlign: "center" }}>
            Can&apos;t access the EHR?
          </Text>

          <Text variant="body1" sx={{ marginTop: 1, textAlign: "center", textWrap: "balance" }}>
            If you can&apos;t log in, please ask a supervisor at the workplace for help. Clipboard
            Support can also reach out to the workplace on your behalf.
          </Text>
        </Box>

        <DialogFooter orientation="vertical" LinkComponent={Link} sx={{ marginTop: 6 }}>
          <SystemInlineBanner iconType="pencil" color="neutral">
            While waiting for access, complete as much documentation as you can on paper.
          </SystemInlineBanner>

          <Button fullWidth size="large" sx={{ marginTop: 2 }} onClick={handleMessageWorkplace}>
            Message the workplace
          </Button>

          <TextButton size="large" LinkComponent={Link} onClick={handleContactSupport}>
            Contact support
          </TextButton>
        </DialogFooter>
      </BottomSheet>
    </ThemeProvider>
  );
}
